import { render, staticRenderFns } from "./jiageshenheLessNew.vue?vue&type=template&id=1c2d7b8e&scoped=true"
import script from "./jiageshenheLessNew.vue?vue&type=script&lang=js"
export * from "./jiageshenheLessNew.vue?vue&type=script&lang=js"
import style0 from "./jiageshenheLessNew.vue?vue&type=style&index=0&id=1c2d7b8e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c2d7b8e",
  null
  
)

export default component.exports